import Head from 'next/head';
import { Box, Container, Typography} from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';


import app from 'firebase/compat/app';
import 'firebase/compat/firestore';
import OrderCard from './OrderCard';
import { useParams } from 'react-router-dom';

const db = app.firestore();

const AddOrder = () => {
  const { id } = useParams();

  return (
    <>
      <Head>
        <title>
          Ajouter livraison
        </title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 3
        }}
      >
        <Container maxWidth="md">
          <Typography
            sx={{ mb: 3 }}
            variant="h4"
          >
            Ajouter une nouvelle livraison
          </Typography>
          <OrderCard orderId={id} isUpdate={false}/>
          {/* <Box sx={{ mt: 3 }}>
            <OrdersFullPanel />
          </Box> */}
        </Container>
      </Box>
    </>
  )
};

AddOrder.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default AddOrder;
